/* Mavelli: nákupní blok na produktu.
   - balíček (1 kus / 2 kusy s výběrem druhých / 2 páry) a doplněk (dárkové balení):
     před odesláním formuláře Dawn přidá doplňkové položky do košíku přes /cart/add.js,
     pak nechá Dawn přidat hlavní produkt a překreslit košík.
   - odhad doručení: N až M pracovních dní bez víkendů a českých svátků. */
(function () {
  var HOL = ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26', '2026-4-3', '2026-4-6', '2027-3-26', '2027-3-29', '2028-4-14', '2028-4-17'];
  function isOff(d) {
    var k = d.getMonth() + 1 + '-' + d.getDate();
    return d.getDay() === 0 || d.getDay() === 6 || HOL.indexOf(k) > -1 || HOL.indexOf(d.getFullYear() + '-' + k) > -1;
  }
  function addBiz(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (!isOff(d)) n--; }
    return d;
  }
  function fmt(d) { return d.getDate() + '. ' + (d.getMonth() + 1) + '.'; }

  function initEta(root) {
    if (root.dataset.znackaInit) return; root.dataset.znackaInit = '1';
    var min = parseInt(root.dataset.min, 10) || 5, max = parseInt(root.dataset.max, 10) || 12;
    var a = addBiz(min), b = addBiz(max);
    var range = a.getMonth() === b.getMonth() ? a.getDate() + '.–' + fmt(b) : fmt(a) + ' až ' + fmt(b);
    var r = root.querySelector('[data-eta-range]'); if (r) r.textContent = range;
    var t = root.querySelector('[data-eta-today]'); if (t) t.textContent = 'dnes, ' + fmt(new Date());
    var to = root.querySelector('[data-eta-to]'); if (to) to.textContent = fmt(a) + ' až ' + fmt(b);
  }

  // 199000 → „1 990 Kč“ (stejně jako money_without_trailing_zeros v theme)
  function money(c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč'; }

  // Sleva 70 % se v košíku odečte z levnějších hodinek páru: pár = dražší + 30 % levnějších.
  function initBundle(root) {
    if (root.dataset.znackaInit) return; root.dataset.znackaInit = '1';
    var chips = root.querySelectorAll('.znacka-chip');
    var mainPrice = parseInt(root.dataset.price, 10) || 0;
    var pick = null;
    chips.forEach(function (c) { if (!pick && c.dataset.product !== root.dataset.product) pick = c; });
    if (!pick && chips.length) pick = chips[0];
    function varSel() { return pick ? root.querySelector('.znacka-chipvar[data-for="' + pick.dataset.product + '"]') : null; }
    function secondId() { var s = varSel(); return s ? s.value : (pick ? pick.dataset.variant : null); }
    function secondPrice() {
      var s = varSel(), o = s && s.selectedOptions[0];
      return parseInt(o ? o.dataset.price : (pick ? pick.dataset.price : mainPrice), 10) || mainPrice;
    }
    function prices() {
      var a = mainPrice, b = secondPrice(), lo = Math.min(a, b), hi = Math.max(a, b);
      var pair = hi + Math.floor(lo * 3 / 10);
      var t = root.querySelector('[data-znacka-second]');
      if (t) t.textContent = b > a ? 'levnější z páru −70 %' : 'druhé za ' + money(pair - a);
      var p = root.querySelector('[data-znacka-pair]'); if (p) p.textContent = money(pair);
      var d = root.querySelector('[data-znacka-double]'); if (d) d.textContent = money(pair * 2);
    }
    function mark() {
      chips.forEach(function (c) { var on = c === pick; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var cur = varSel();
      root.querySelectorAll('.znacka-chipvar').forEach(function (s) { s.classList.toggle('is-on', s === cur); });
      prices();
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        pick = c; mark();
        var two = root.querySelector('input[value="2"]'); if (two) two.checked = true;
        refresh();
        root.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    root.querySelectorAll('.znacka-chipvar').forEach(function (s) {
      s.addEventListener('click', function (e) { e.stopPropagation(); });
      s.addEventListener('change', prices);
    });
    function refresh() {
      root.querySelectorAll('.znacka-tier').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
    }
    root.querySelectorAll('input[type=radio]').forEach(function (i) { i.addEventListener('change', refresh); });
    root.znackaPick = secondId;
    mark(); refresh();
  }

  // Fotky barev na produktu přepínají skrytý výběr varianty z Dawn
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-znacka-vthumb]');
    if (!b) return;
    var info = b.closest('product-info') || document;
    var vs = info.querySelector('variant-selects');
    if (!vs) return;
    var sel = vs.querySelector('select');
    if (sel) {
      sel.value = b.dataset.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var r = Array.prototype.find.call(vs.querySelectorAll('input[type=radio]'), function (i) { return i.value === b.dataset.value; });
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var sw = b.closest('[data-znacka-sw]');
    sw.querySelectorAll('[data-znacka-vthumb]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var n = sw.querySelector('[data-znacka-sw-name]'); if (n) n.textContent = b.dataset.value;
  });

  // form.id nejde použít: produktový formulář má pole name="id", které vlastnost id zastíní
  function formId(form) { return (form.getAttribute && form.getAttribute('id')) || ''; }

  function extrasFor(form) {
    var section = formId(form).replace('product-form-', '');
    var items = [], mainQty = null;
    var bundle = document.querySelector('[data-znacka-bundle][data-section="' + section + '"]');
    if (bundle) {
      var t = bundle.querySelector('input[type=radio]:checked');
      var tier = t ? t.value : '1';
      var second = bundle.znackaPick && bundle.znackaPick();
      if (tier === '2' && second) items.push({ id: +second, quantity: 1 });
      if (tier === '4' && second) { items.push({ id: +second, quantity: 2 }); mainQty = 2; }
    }
    document.querySelectorAll('[data-znacka-addon][data-section="' + section + '"]:checked').forEach(function (c) {
      items.push({ id: +c.dataset.znackaAddon, quantity: 1 });
    });
    return { items: items, mainQty: mainQty };
  }

  function setQty(form, q) {
    var input = form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + formId(form) + '"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'quantity'; input.dataset.znacka = '1'; form.appendChild(input); }
    input.value = q;
  }

  // Zachytit odeslání dřív než product-form.js z Dawn (fáze capture na dokumentu).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || formId(form).indexOf('product-form-') !== 0) return;
    if (form.dataset.znackaPassed === '1') return;
    var ex = extrasFor(form);
    var own = form.querySelector('input[name="quantity"][data-znacka]');
    if (ex.mainQty) setQty(form, ex.mainQty); else if (own) own.remove();
    if (!ex.items.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ex.items })
    }).finally(function () {
      form.dataset.znackaPassed = '1';
      var btn = form.querySelector('[type="submit"]');
      if (form.requestSubmit) form.requestSubmit(btn || undefined); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      form.dataset.znackaPassed = '';
    });
  }, true);


  // Přilepené tlačítko na mobilu: objeví se, když hlavní tlačítko odjede nahoru z obrazovky
  function initSticky() {
    // Dawn má na stránce i formulář product-form-installment-… (splátky), ten přeskočit
    var form = document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    if (!form || document.querySelector('.znacka-sticky')) return;
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var title = (document.querySelector('.product__title h1') || {}).textContent || '';
    var img = document.querySelector('.product__media img');
    var bar = document.createElement('div');
    bar.className = 'znacka-sticky';
    bar.innerHTML = (img ? '<img src="' + img.currentSrc + '" alt="">' : '') +
      '<span class="znacka-sticky__t"><b></b><span></span></span><button type="button">Přidat do košíku</button>';
    bar.querySelector('b').textContent = title.trim();
    document.body.appendChild(bar);
    var section = formId(form).replace('product-form-', '');
    function summary() {
      var bundle = document.querySelector('[data-znacka-bundle][data-section="' + section + '"]');
      var t = bundle && bundle.querySelector('input[type=radio]:checked');
      var l = t && t.closest('.znacka-tier');
      var s = l ? l.querySelector('.znacka-tier__t b').textContent + ' · ' + l.querySelector('.znacka-tier__p').textContent : '';
      bar.querySelector('.znacka-sticky__t span').textContent = s;
    }
    summary();
    document.addEventListener('change', summary);
    bar.querySelector('button').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
    });
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(btn);
  }

  // Taby na produktu
  function initTabs(root) {
    if (root.dataset.znackaInit) return; root.dataset.znackaInit = '1';
    var btns = root.querySelectorAll('[role="tab"]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) {
          var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; panel.classList.toggle('is-on', on); }
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-znacka-eta]').forEach(initEta);
    document.querySelectorAll('[data-znacka-bundle]').forEach(initBundle);
    initSticky();
    document.querySelectorAll('[data-znacka-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // Rychlý nákup z karty (okno Dawn) vloží produkt až po kliknutí
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () {
      pending = false;
      document.querySelectorAll('[data-znacka-eta]:not([data-znacka-init])').forEach(initEta);
      document.querySelectorAll('[data-znacka-bundle]:not([data-znacka-init])').forEach(initBundle);
      document.querySelectorAll('[data-znacka-tabs]:not([data-znacka-init])').forEach(initTabs);
    }, 50);
  }).observe(document.body, { childList: true, subtree: true });
})();
